module.exports = __webpack_public_path__ + "media/images/lp_consultation/agency-step01-a744573156ed6f0cd3b9b196eb91ccb3.jpg";